export const declineValidation = ({ declineReason }) => {
  const errors = {};
  if (!declineReason) {
    errors.declineReason = "* Required";
  }

  return errors;
};
